
















import Vue from 'vue'

export default Vue.extend({
  name: 'cc-bonus-display',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
})
